import { useMutation, useQueryClient } from '@tanstack/react-query';
import { postFinanceEntry } from '@services/registry';

export function usePostFinanceEntry({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ accountId, type, date, particulars, amount }) => {
            return await postFinanceEntry({ tenantId, accountId, type, date, particulars, amount });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['financeSummary', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeAccounts', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeEntries', tenantId] });
        },
    });
}

